/**
 * Created by Kristy Kavvada on 07/2/2020.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('customerMedReportsSumsPerMonth', {
                parent: 'customerMedReports',
                url: '/per-month',
                data: {
                    authorities: ['ROLE_CHECKER'],
                    pageTitle: 'sigmaCrmApp.customer.home.title'
                },
                templateUrl: 'app/displays/adminCustomers/medReports/medReportSumsPerMonth/medReportSumsPerMonth.html',
                controller: 'AdminCustomerViewMedReportsSumsPerMonthController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
